var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pi-ai-nav",attrs:{"aria-label":"Seções do assistente"}},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.key,staticClass:"pi-ai-nav__link",class:{ 'is-on': _vm.current === link.key },attrs:{"to":link.to,"aria-current":_vm.current === link.key ? 'page' : null}},[_vm._v(_vm._s(link.label))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16704eef","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/pi/piAssistantNav.vue
// module id = 1828
// module chunks = 0